exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mp-step-range {\n  align-items: center;\n  display: flex;\n  font-size: 14px;\n}\n.mp-step-range mp-select {\n  font-size: 14px;\n}\n.mp-step-range .mp-step-range-label {\n  color: #8f8f91;\n  font-weight: 500;\n  line-height: 1;\n  padding-right: 8px;\n}\n", ""]);

// exports
